import { Link } from "react-router-dom";
import { ArrowUpRight } from "@phosphor-icons/react";

const cols = [
  {
    title: "Company",
    links: [
      { l: "What We Do", to: "/what-we-do" },
      { l: "How We Work", to: "/how-we-work" },
      { l: "About Eazymuv", to: "/about" },
      { l: "Our Team", to: "/team" },
      { l: "Careers", to: "/careers" },
    ],
  },
  {
    title: "Ecosystem",
    links: [
      { l: "Eazymuv OS", to: "/eazymuv-os" },
      { l: "Products Overview", to: "/products" },
      { l: "EazyMS", to: "/eazyms" },
      { l: "Industries", to: "/industries" },
    ],
  },
  {
    title: "More",
    links: [
      { l: "Insights", to: "/insights" },
      { l: "Contact", to: "/contact" },
      { l: "Privacy Policy", to: "/privacy" },
      { l: "Terms of Use", to: "/terms" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-os-bg text-white relative overflow-hidden grain" data-testid="main-footer">
      <div className="grid-bg-dark absolute inset-0 opacity-40" />
      <div className="relative max-w-[1600px] mx-auto px-5 md:px-8 py-16 md:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <img src="/eazymuv-logo.jpeg" alt="Eazymuv" className="h-12 w-auto" />
            <p className="mt-6 max-w-md text-white/60 leading-relaxed">
              A technology-enabled supply chain execution company. One accountable
              operating partner across factory, warehouse and logistics.
            </p>
            <Link
              to="/contact"
              data-testid="footer-cta"
              className="mt-8 inline-flex items-center gap-2 bg-ez-yellow text-ez-text px-6 py-3 font-semibold hover:bg-white transition-colors"
            >
              Discuss Your Operations <ArrowUpRight size={18} weight="bold" />
            </Link>
          </div>
          <div className="lg:col-span-7 grid grid-cols-2 md:grid-cols-3 gap-8">
            {cols.map((col) => (
              <div key={col.title}>
                <div className="font-mono-ez text-xs uppercase tracking-widest text-ez-yellow mb-5">
                  {col.title}
                </div>
                <ul className="space-y-3">
                  {col.links.map((link) => (
                    <li key={link.to}>
                      <Link
                        to={link.to}
                        className="text-sm text-white/70 hover:text-white transition-colors"
                      >
                        {link.l}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 text-xs text-white/40 font-mono-ez">
          <span>© {new Date().getFullYear()} Eazymuv Technologies Pvt Ltd. All rights reserved.</span>
          <span>Execution, instrumented. — EazyOS: 100% visibility for supply chains.</span>
        </div>
      </div>
    </footer>
  );
}
